import { useCallback, useContext, useState } from 'react';
import { Redirect } from 'react-router-dom';

import { ApiGetCompanyType } from '../../api/types/apiGetCompany';
import { ROUTE } from '../../App';
import { Context, GoogleReCaptcha, Loader } from '../../components';
import { Wizard } from '../../components/Wizard';
import { api } from '../../sagas';

import Step0 from './Steps/Step0';
import Step1 from './Steps/Step1';
import Step2 from './Steps/Step2';

export type NameValueType = {
	name: string;
	value: string;
};

function BusinessPlanWelcome() {
	const [gotoDashboard, setGotoDashboard] = useState(false);
	const [companyData, setCompanyData] = useState<ApiGetCompanyType>({
		name: null,
		emailDomains: [],
		businessUnits: [],
		location: null,
		logo: null,
	} as ApiGetCompanyType);

	const { googleToken, setGoogleToken, isLoader } = useContext(Context);

	const handleCaptchaVerify = useCallback((newToken: string) => {
		setGoogleToken(newToken);
	}, []);

	const handleSubmit = (data: ApiGetCompanyType) => {
		api.uploadCompanyInfo(data).then((response: any) => {
			if (response.ok) {
				setGotoDashboard(true);
			}
		});
	};

	if (isLoader) return <Loader />;

	if (gotoDashboard) return <Redirect to={ROUTE.dashboard} />;

	return (
		<>
			{!googleToken && <GoogleReCaptcha onVerify={handleCaptchaVerify} />}
			<Wizard>
				<Step0 />
				<Step1 setCompanyInfo={setCompanyData} />
				<Step2
					setEmailDomainValue={(data) => {
						handleSubmit({
							...companyData,
							emailDomains: data,
						});
					}}
					companyInfo={companyData}
				/>
			</Wizard>
		</>
	);
}

export default BusinessPlanWelcome;
